import { render, staticRenderFns } from "./DigitalSignWitness.vue?vue&type=template&id=46bdd4a8&"
import script from "./DigitalSignWitness.vue?vue&type=script&lang=js&"
export * from "./DigitalSignWitness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports